import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Dashboard from '../Dashboard/Dashboard';
import PipelineDashboardHome from './PipelineDashboardHome';
import { isPipelineParticipant } from './pipelineUtils';

export default function HomeDashboard() {
  const { user } = useAuth();
  if (isPipelineParticipant(user?.role)) {
    return <PipelineDashboardHome />;
  }
  return <Dashboard />;
}
